import { KeyValueT } from '@hypercharge/bbs-website-commons/lib/types/bbs';
import { CheckOutlined } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';
import { BREAKPOINTS } from '../../utils/constants';

type EquipmentProps = {
  equipments: KeyValueT[];
};

const ScWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  @media print {
    display: none;
  }
`;

const ScItem = styled.div`
  width: 100%;

  @media screen and (min-width: ${BREAKPOINTS.sm}px) {
    width: 50%;
  }

  @media screen and (min-width: ${BREAKPOINTS.md}px) {
    width: 25%;
  }

  @media print {
    width: 25%;
    font-size: 10px;
  }

  i,
  span {
    margin-right: 5px;
    color: #52c41a;
  }
`;

const Equipment = ({ equipments }: EquipmentProps) => {
  return (
    <ScWrapper>
      {equipments.map((equipment, i) => {
        return (
          <ScItem key={i}>
            <CheckOutlined />

            {equipment.key}
          </ScItem>
        );
      })}
    </ScWrapper>
  );
};

export { Equipment };
